import src from "IMAGE";
export default { src, width: 522, height: 197, blurWidth: 0, blurHeight: 0};
